import { ExamplePageTemplate } from "./components";
import { legalConfig } from "./configs/exampleConfigs";

const LegalExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={legalConfig.backgroundColor}
      chatButtonColor={legalConfig.chatButtonColor}
      chatButtonIcon={legalConfig.chatButtonIcon}
      header={legalConfig.header}
      hero={legalConfig.hero}
    >
      {legalConfig.content}
    </ExamplePageTemplate>
  );
};

export default LegalExample;